module.exports = __webpack_public_path__ + "static/media/Eden_Pharma_Logo.79b6b6d1.png";